<div class="flex justify-center">

<div class="kt-card p-8 w-[380px]">

<h3 class="text-lg mb-6">
Two Factor Verification
</h3>

<input
class="kt-input"
placeholder="Enter 6 digit code"
[(ngModel)]="otp"
maxlength="6"
/>

<button
class="kt-btn kt-btn-primary mt-4 w-full"
(click)="verify()"
>

Verify

</button>

<div
*ngIf="error"
class="text-red-500 mt-3"
>

{{error}}

</div>

</div>

</div>
